import { useEffect, useRef } from "react";
import {
  FLOW_PARAMETER,
  PAGE_PARAMETER,
  SAVED_VIEW_PARAMETER,
  SEED_PARAMETER,
} from "../helpers/constants/miscellaneous";
import { useLocation, useNavigate } from "react-router";

export const useClearSavedSearchParam = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const prevSearchRef = useRef(location.search);

  useEffect(() => {
    const currentSearchParams = new URLSearchParams(location.search);
    const prevSearchParams = new URLSearchParams(prevSearchRef.current);

    const currentSavedView = currentSearchParams.get(SAVED_VIEW_PARAMETER);
    const prevSavedView = prevSearchParams.get(SAVED_VIEW_PARAMETER);

    const ignoredFilters = [PAGE_PARAMETER, FLOW_PARAMETER, SEED_PARAMETER];

    ignoredFilters.forEach((filter) => {
      currentSearchParams.delete(filter);
      prevSearchParams.delete(filter);
    });

    const currentSearchString = currentSearchParams.toString();
    const prevSearchString = prevSearchParams.toString();

    // If the saved view is still the same and other filters changed, remove the saved view
    if (
      currentSavedView &&
      currentSavedView === prevSavedView &&
      currentSearchString !== prevSearchString
    ) {
      let newSearchParam = new URLSearchParams(location.search);
      newSearchParam.delete(SAVED_VIEW_PARAMETER);
      navigate({ search: newSearchParam.toString() }, { replace: true });
    }

    prevSearchRef.current = location.search;

    //eslint-disable-next-line
  }, [location.search]);
};
